import React, { useMemo } from 'react';
import { ImageList, ImageListItem, useMediaQuery } from '@mui/material';

import MediaCard from '../media-card/MediaCard';

function MediaGallery({ favoriteMedia, additionalCardActions }) {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const colsCount = useMemo(() => {
    if (isMobile) return 1;
    return 2;
  }, [isMobile]);

  return (
    <ImageList variant='masonry' cols={colsCount} gap={8}>
      {favoriteMedia.map((item) => (
        <ImageListItem key={item.id}>
          <MediaCard id={item.id} sourceExists={item.sourceExists} additionalCardActions={additionalCardActions} />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

export default MediaGallery;
